import { ajax } from "lib/observable";
import { Observable } from "rxjs";
import "rxjs/add/operator/map";
import { PAYMENTS_MANAGEMENT } from "constants/action-types";
import siteConfig from "site-config";
import { updateEntities } from "redux-query";
import { getRecordsFromSchema, normalizeData } from "lib/api";
import { Summary as SummarySchema } from "schemas/payments";
import { getNuorderProcessorAccounts } from "components/payments/helpers";
import * as qs from "qs";

export const fetchPaymentsSummaryEpic = (action$, store) =>
    action$.ofType(PAYMENTS_MANAGEMENT.SUMMARY.FETCH.START).mergeMap(({ payload }) => {
        const { scope, paymentSummary } = store.getState();
        //const { currencyCode = "USD" } = payload;
        const nuorderPaymentAccounts = getNuorderProcessorAccounts(scope.brand.modules.payments.accounts);
        let account = nuorderPaymentAccounts.find((account) => {
            return account.currency_code === paymentSummary.currencyCode;
        });
        account = account || nuorderPaymentAccounts[0];

        const query = {
            transaction_date_gte: paymentSummary.startDate.utc().startOf("day").valueOf(),
            transaction_date_lte: paymentSummary.endDate.utc().endOf("day").valueOf(),
        };

        const url = `${siteConfig.api}/api/v3.0/transactions/account/${account._id}/summary?${qs.stringify(query)}`;

        return ajax(url)
            .flatMap(({ response, status, xhr }) => {
                const { data } = response;
                const records = getRecordsFromSchema(SummarySchema);
                const normalizedData = normalizeData(data, SummarySchema, records);

                return [
                    updateEntities({
                        paymentsSummary: (current) => {
                            return {
                                ...current,
                                ...normalizedData.entities.paymentsSummary,
                            };
                        },
                    }),
                    {
                        payload: normalizedData.result,
                        type: PAYMENTS_MANAGEMENT.SUMMARY.FETCH.COMPLETED,
                    },
                ];
            })
            .catch((error) => {
                return Observable.merge(
                    Observable.of({
                        error: true,
                        payload: error,
                        type: PAYMENTS_MANAGEMENT.SUMMARY.FETCH.COMPLETED,
                    })
                );
            });
    });
